import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, HomeIcon } from 'lucide-react';
const VIDEO_URL = 'https://i.imgur.com/EGQFyeh.mp4';
const POSTER_URL = 'https://i.imgur.com/908kujZ.jpeg';
const NIGHT_URL = 'https://i.imgur.com/WGxCybn.png';
export function Hero() {
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const handleLoaded = () => {
      video.playbackRate = 0.6;
    };
    video.addEventListener('loadedmetadata', handleLoaded);
    return () => video.removeEventListener('loadedmetadata', handleLoaded);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      const video = videoRef.current;
      if (video && window.scrollY < window.innerHeight) {
        video.style.transform = `translate(-50%, -50%) translateY(${window.scrollY * 0.06}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <section id="inicio" className="relative h-screen min-h-[600px] overflow-hidden flex items-center justify-center" data-id="element-219" data-mp="3o7c1c19oavi7">
      <video ref={videoRef} className="absolute top-1/2 left-1/2 min-w-full min-h-full w-auto h-auto object-cover -translate-x-1/2 -translate-y-1/2 z-0" autoPlay muted loop playsInline preload="auto" poster={POSTER_URL} data-id="element-220" data-mp="39b4ip5dwy251">
        <source src={VIDEO_URL} type="video/mp4" data-id="element-221" data-mp="3599ki9ra44vh" />
      </video>

      <div className="absolute inset-0 z-[1] bg-cover animate-night-fade" style={{
      backgroundImage: `url('${NIGHT_URL}')`,
      backgroundPosition: 'center 35%'
    }} data-id="element-222" data-mp="35akmc415z2jy" />

      <div className="absolute inset-0 z-[2] bg-[linear-gradient(to_bottom,rgba(0,0,0,.12)_0%,rgba(0,0,0,.02)_30%,rgba(0,0,0,.42)_70%,rgba(0,0,0,.88)_100%)]" data-id="element-223" data-mp="2vj7sx7zpw4bt" />

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 0.6
    }} className="hidden sm:flex absolute top-6 right-8 lg:right-12 z-[4] items-center gap-2" data-id="element-224" data-mp="2ll0i76w0uii9">
        <span className="w-[7px] h-[7px] rounded-full animate-cycle-dot" data-id="element-225" data-mp="na09x0zpb7f8" />
        <span className="text-[0.58rem] tracking-[0.2em] uppercase text-white/45" data-id="element-226" data-mp="id02omr47ymj">Amanecer · Tolima</span>
      </motion.div>

      <div className="relative z-[3] text-center px-6 max-w-[860px] w-full" data-id="element-227" data-mp="deyh9v67vn7w">
        <motion.div initial={{
        opacity: 0,
        y: -18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} className="inline-flex items-center gap-2 bg-white/[0.08] backdrop-blur-md border border-white/[0.18] rounded-full px-5 py-2 mb-7 text-xs font-medium tracking-[0.1em] text-gold-light" data-id="element-228" data-mp="1azkqjd8dtslc">
          <motion.span animate={{
          scale: [1, 1.6, 1],
          opacity: [1, 0.6, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="w-1.5 h-1.5 rounded-full bg-[#5a9f5a]" data-id="element-229" data-mp="3ltglflt1eim8" />
          Payandé, Tolima &nbsp;·&nbsp; Pet Friendly &nbsp;·&nbsp; Glamping de Lujo
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 25
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.2
      }} style={{
        textShadow: '0 2px 20px rgba(0,0,0,0.25)'
      }} className="font-display text-[2.8rem] sm:text-6xl lg:text-[6.5rem] font-light leading-[1.05] text-white mb-6" data-id="element-230" data-mp="21bfxpwbcvrxm">
          Donde el lujo
          <br data-id="element-231" data-mp="2kxudjgfp1e4n" />
          <em className="italic text-gold-light" data-id="element-232" data-mp="2kxc6dorhtfhy">abraza la naturaleza</em>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 25
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.3
      }} className="text-sm sm:text-base font-light text-white/70 mb-10 leading-[1.75]" data-id="element-233" data-mp="2p1sb3mpdegvl">
          9 cabañas únicas rodeadas de montañas y vegetación exuberante.
          <br data-id="element-234" data-mp="znn82dsd6ezz" />
          Desconéctate del mundo. Conéctate contigo.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 25
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.4
      }} className="flex items-center justify-center gap-4 flex-wrap" data-id="element-235" data-mp="49jco3qr0lll">
          <a href="#reserva" className="inline-flex items-center gap-2 bg-gold text-night px-7 py-3.5 rounded-full text-xs font-semibold tracking-wide uppercase transition-all hover:bg-gold-light hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(201,169,110,0.45)] w-full sm:w-auto max-w-[280px] sm:max-w-none justify-center" data-id="element-236" data-mp="9aqkg2sw5ks9">
            <CalendarIcon className="w-[15px] h-[15px]" strokeWidth={2.5} data-id="element-237" data-mp="3rheqpvzogdzi" />
            Consultar Disponibilidad
          </a>
          <a href="#cabanas" className="inline-flex items-center gap-2 bg-transparent text-white px-7 py-3.5 rounded-full text-xs font-normal tracking-wide uppercase border border-white/35 transition-all hover:border-gold hover:text-gold hover:-translate-y-1 w-full sm:w-auto max-w-[280px] sm:max-w-none justify-center" data-id="element-238" data-mp="2yzstjlmspfxk">
            <HomeIcon className="w-[15px] h-[15px]" strokeWidth={2} data-id="element-239" data-mp="1eayk38vqukua" />
            Ver Cabañas
          </a>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.9,
      delay: 0.7
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 z-[3] flex flex-col items-center gap-2" data-id="element-240" data-mp="14jkdyi9aems6">
        <span className="text-[0.6rem] tracking-[0.25em] uppercase text-white/40" data-id="element-241" data-mp="1x6x1ovr6p0n2">Explorar</span>
        <div className="w-px h-11 bg-gradient-to-b from-white/40 to-transparent animate-scroll-line" data-id="element-242" data-mp="1j7oylrrwh8dl" />
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.9,
      delay: 0.7
    }} className="hidden md:block absolute bottom-10 right-8 lg:right-12 z-[3] text-right" data-id="element-243" data-mp="1n88w4wgdye09">
        <p className="text-[0.6rem] tracking-[0.15em] text-white/35 uppercase leading-[2]" data-id="element-244" data-mp="2ehap9mhjkg5w">Payandé · San Luis, Tolima</p>
        <p className="text-[0.6rem] tracking-[0.15em] text-white/35 uppercase leading-[2]" data-id="element-245" data-mp="29i7hvve39xur">A 30 min de Ibagué</p>
        <p className="text-[0.6rem] tracking-[0.15em] text-white/35 uppercase leading-[2]" data-id="element-246" data-mp="24qpjnf3gabdh">
          Clima Cálido · Montañas del Tolima
        </p>
      </motion.div>
    </section>;
}